// 用户接口api
import qs from 'qs'
import request from '@/utils/request' // axios request 请求方法
// 接口基础路径
const preUrlPath = process.env.API_PRE_URL

// 接口对象
const userApi = {
  // 登陆
  login: {
    r: (params) => {
      return new Promise((resolve, reject) => {
        request.post(`${preUrlPath}/login`, qs.stringify(params)).then((res) => {
          resolve(res.data)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },
  // 注销
  logoff: {
    r: (params) => {
      return new Promise((resolve, reject) => {
        request.get(`${preUrlPath}/logoff`, {
          params: params
        }).then((res) => {
          resolve(res.data)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },
  // 需求信息更新
  demandUpdate: {
    r: (params) => {
      return new Promise((resolve, reject) => {
        request.post(`${preUrlPath}/demand/update`, params).then((res) => {
          resolve(res.data)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },
  // 需求列表筛选
  getDemandList: {
    r: (params) => {
      return new Promise((resolve, reject) => {
        request.post(`${preUrlPath}/demand/list`, params).then((res) => {
          resolve(res.data)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },
  // 用户提交需求
  demandCommit: {
    r: (params) => {
      return new Promise((resolve, reject) => {
        request.post(`${preUrlPath}/demand/a/commit`, params).then((res) => {
          resolve(res.data)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },
  // 钉钉机器人发送消息，接口设置在了nginx中，没有走后台，所以本接口的基础路径为自身
  dingdingRobotSendMessage: {
    r: (params) => {
      return new Promise((resolve, reject) => {
        request.post(`/dingtalk`, params).then((res) => {
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  }
  // // 用户注册，post提交，传参json格式
  // register: {
  //   r: (params) => {
  //     return new Promise((resolve, reject) => {
  //       request.post(`${preUrlPath}/acc/doRegister`, params).then((res) => {
  //         resolve(res)
  //       }).catch((error) => {
  //         reject(error)
  //       })
  //     })
  //   }
  // }
  // // 用户登录，post提交，传参json格式
  // login: {
  //   r: (params) => {
  //     return new Promise((resolve, reject) => {
  //       request.post(`${preUrlPath}/acc/doPhoneLogin`, params).then((res) => {
  //         resolve(res)
  //       }).catch((error) => {
  //         reject(error)
  //       })
  //     })
  //   }
  // },
  // // 用户找回密码，post提交，传参query格式
  // getUserPassword1: {
  //   r: (params) => {
  //     return new Promise((resolve, reject) => {
  //       request.post(`${preUrlPath}/acc/doResetPwd`, qs.stringify(params)).then((res) => {
  //         resolve(res)
  //       }).catch((error) => {
  //         reject(error)
  //       })
  //     })
  //   }
  // },
  // // 获取用户信息，传参formdata格式
  // getUserInfo1: {
  //   r: (params) => {
  //     return new Promise((resolve, reject) => {
  //       request.get(`${preUrlPath}/user/material/userInfo`, {
  //         params: qs.stringify(params)
  //       }).then((res) => {
  //         resolve(res)
  //       }).catch((error) => {
  //         reject(error)
  //       })
  //     })
  //   }
  // },
  // // 获取用户信息，传参json格式
  // getUserInfo2: {
  //   r: (params) => {
  //     return new Promise((resolve, reject) => {
  //       request.get(`${preUrlPath}/user/material/userInfo`, {
  //         params: params
  //       }).then((res) => {
  //         resolve(res)
  //       }).catch((error) => {
  //         reject(error)
  //       })
  //     })
  //   }
  // }
}

export default userApi



// WEBPACK FOOTER //
// ./src/api/modules/user.js